<template>
  <div class="ly-c-page ly-c-custom-page">
    <div v-if="totalFlag" class="total-flag">
      <span style="margin-right: 4px">共{{ paginations.total }}条记录</span>
      <span
        v-if="showCurrentPage && showCurrentFlag"
        class="current-flag"
        style="white-space: nowrap; margin-right: 4px"
      >
        第{{
          paginations.pageNum > totalPageNum()
            ? totalPageNum()
            : paginations.pageNum
        }}/{{ totalPageNum() }}页
      </span>
    </div>
    <el-pagination
      background
      small
      :pager-count="pagerCount"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginations.pageNum"
      :page-sizes="paginations.sizes ? paginations.sizes : sizes"
      :page-size="paginations.pageSize"
      :layout="pageLayout"
      :prev-text="isPageText ? '上一页' : ''"
      :next-text="isPageText ? '下一页' : ''"
      :total="paginations.total"
      :class="{ 'page-text': isPageText }"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "sino-pagination",
  props: {
    paginations: {
      //分页
      type: Object,
      default: () => {
        return {};
      },
    },
    pagerCount: {
      //页码按钮的数量，当总页数超过该值时会折叠
      type: Number,
      default: 7,
    },
    totalFlag: {
      type: Boolean,
      default: true,
    },
    pageLayout: {
      type: String,
      default: "prev, pager, next, sizes, jumper",
    },
    isPageText: {
      type: Boolean,
      default: false,
    },
    showCurrentPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sizes: [10, 20, 50, 100],
      num: 1,
      showCurrentFlag: true,
    };
  },
  mounted() {
    this.calcCurrentPage();
  },
  methods: {
    /**计算总页数 */
    totalPageNum() {
      let total = this.paginations.total;
      let pagesize = this.paginations.pageSize;
      let page = Number(total) % Number(pagesize);
      let num = 1;
      if (page == 0) {
        num = Number(total) / Number(pagesize);
      } else {
        num = Math.ceil(Number(total) / Number(pagesize));
      }
      return num;
    },
    handleSizeChange(val) {
      this.$emit("size-change", val);
    },
    handleCurrentChange(val) {
      this.$emit("current-change", val);
    },
    // 计算当前页能否放的下
    calcCurrentPage() {
      let flag = true;
      let totalFlag = document.querySelector(".ly-c-custom-page .total-flag");
      let currentFlag = document.querySelector(
        ".ly-c-custom-page .current-flag"
      );
      if (this.showCurrentPage && currentFlag) {
        let totalFlagH = totalFlag.offsetHeight;
        let currentFlagH = currentFlag.offsetHeight;
        if (totalFlagH > currentFlagH) {
          flag = false;
        }
      }
      this.showCurrentFlag = flag;
    },
  },
};
</script>
